import { useState, forwardRef } from "react";
import PropTypes from "prop-types";
import { Box, styled } from "@mui/system";
import { Modal, TextField } from "@mui/material";
import Fade from "@mui/material/Fade";
import { Button } from "@mui/material";

const CrearListaModal = ({ onSumit }) => {
  const [open, setOpen] = useState(false);
  const [focus, setFocus] = useState("");
  const [lista, setLista] = useState({
    label: "",
    options: [
      { icon: "a", text: "text a" },
      { icon: "b", text: "text b" },
    ],
  });
  const [newOption, setNewOption] = useState({ icon: "", text: "" });
  const [error, setError] = useState({
    errorOption: false,
    messageOption: "",
    errorTitle: false,
    messageTitle: "",
  });
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const addOption = () => {
    if (!newOption.text) {
      setError({ ...error, errorOption: true, messageOption: "Texto vacío" });
      return;
    }
    let option = newOption;
    setLista({ ...lista, options: [...lista.options, option] });
    setNewOption({ ...newOption, icon: "", text: "" });
  };

  const crearPanel = () => {
    if (!lista.label) {
      setError({ ...error, errorTitle: true, messageTitle: "Titulo vacío" });
      return;
    }
    onSumit(lista);
    handleClose();
  };

  const handleTitle = (event) => {
    if (event.target.value !== "") {
      setError({
        ...error,
        errorTitle: false,
        messageTitle: "",
      });
    }
    setLista({ ...lista, label: event.target.value });
  };

  const handleOption = (event) => {
    if (event.target.value !== "") {
      setError({
        ...error,
        errorOption: false,
        messageOption: "",
      });

      setNewOption({ ...newOption, text: event.target.value });
    }
  };

  return (
    <div>
      <ColorButton onClick={handleOpen}>Agrega sección</ColorButton>
      <StyledModal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: StyledBackdrop }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <div style={{ width: "30rem" }}>
              <div>Icon select</div>
              <TextField
                id="filled-basic"
                label="Texto item"
                variant="filled"
                fullWidth
                error={error.errorOption}
                helperText={error.messageOption}
                onChange={handleOption}
                value={newOption.text}
              />
              <li
                onClick={addOption}
                style={{
                  position: "relative",
                  border: "1px solid lightgray",
                  marginBlock: "2rem",
                }}
              >
                <Button
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    lineHeight: "2.1rem",
                    fontSize: "1rem",
                  }}
                  onClick={addOption}
                >
                  Agregar item
                </Button>
              </li>
              <TextField
                id="filled-basic"
                label="Titulo"
                variant="filled"
                fullWidth
                value={lista.label}
                error={error.errorTitle}
                helperText={error.messageTitle}
                onChange={handleTitle}
              />
              <Button onClick={handleClose}>Cerrar</Button>
              <ColorButton onClick={crearPanel}>Agregar</ColorButton>
            </div>
            <div style={{ minWidth: "20rem", padding: "0.5rem" }}>
              <h3>{lista.label}</h3>
              <ul id="transition-modal-description" style={{ marginTop: 16 }}>
                {lista.options.map((option) => (
                  <li>
                    {option.icon} - {option.text}
                  </li>
                ))}
              </ul>
            </div>
          </Box>
        </Fade>
      </StyledModal>
    </div>
  );
};

export default CrearListaModal;

const Backdrop = forwardRef((props, ref) => {
  const { open, ...other } = props;
  return (
    <Fade in={open}>
      <div ref={ref} {...other} />
    </Fade>
  );
});

Backdrop.propTypes = {
  open: PropTypes.bool,
};

const blue = {
  200: "#99CCF3",
  400: "#3399FF",
  500: "#007FFF",
};

const grey = {
  50: "#f6f8fa",
  100: "#eaeef2",
  200: "#d0d7de",
  300: "#afb8c1",
  400: "#8c959f",
  500: "#6e7781",
  600: "#57606a",
  700: "#424a53",
  800: "#32383f",
  900: "#24292f",
};

const StyledModal = styled(Modal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const style = (theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: "16px 32px 24px 32px",
  backgroundColor: theme.palette.mode === "dark" ? "#0A1929" : "white",
  display: "flex",
  flexWrap: "wrap",
  minWidth: "30rem",
});

const ColorButton = styled(Button)(({ theme }) => ({
  color: "#e3036d",
  backgroundColor: "white",
  borderColor: "#e3036d",
}));
